<!-- components/Aceites/TipsCambioAceites.vue -->
<template>
  <section class="w-full bg-[#F8F8F8]">
    <div class="mx-auto max-w-[1320px] px-5 md:px-10 pt-14 md:pt-24 pb-10 md:pb-16">
      <!-- Título -->
      <h2 class="text-center font-extrabold uppercase tracking-[0.08em] text-ROJO_TITULOS_LEON
               text-[18px] md:text-[22px]">
        TIPS PARA TU CAMBIO DE ACEITE
      </h2>

      <!-- =========================
           DESKTOP: grilla 4 columnas
           (clave: NO fijar widths chicos)
      ========================== -->
      <div class="hidden md:grid mt-12 grid-cols-4 gap-6">
        <article v-for="tip in tips" :key="tip.id"
          class="w-full overflow-hidden rounded-2xl border border-GRIS_CLARO_COMPLEMENTARIO_2 bg-BLANCO_LEON">
          <div class="h-[220px] lg:h-[240px] w-full overflow-hidden">
            <img :src="tip.imagen" :alt="tip.alt" class="h-full w-full object-cover" loading="lazy" decoding="async" />
          </div>

          <div class="px-6 pt-5 pb-6">
            <h3 class="text-[18px] font-extrabold leading-[1.25] text-GRIS_LEON">
              {{ tip.titulo }}
            </h3>

            <div class="mt-4 space-y-4 text-[14px] leading-[1.85] text-GRIS_LEON">
              <component :is="tip.render" />
            </div>
          </div>
        </article>
      </div>

      <!-- =========================
           MOBILE: carrusel (peek)
      ========================== -->
      <div class="md:hidden mt-8">
        <div ref="track_ref" class="tips-track flex gap-4 overflow-x-auto snap-x snap-mandatory px-5 -mx-5"
          @scroll.passive="on_scroll">
          <article v-for="(tip, i) in tips" :key="tip.id" class="snap-center min-w-[88%] w-[88%] overflow-hidden rounded-2xl
                   border border-GRIS_CLARO_COMPLEMENTARIO_2 bg-BLANCO_LEON" :data-index="i">
            <div class="h-[260px] w-full overflow-hidden">
              <img :src="tip.imagen" :alt="tip.alt" class="h-full w-full object-cover" loading="lazy"
                decoding="async" />
            </div>

            <div class="px-6 pt-5 pb-7">
              <h3 class="text-[18px] font-extrabold leading-[1.25] text-GRIS_LEON">
                {{ tip.titulo }}
              </h3>

              <div class="mt-4 space-y-4 text-[14px] leading-[1.9] text-GRIS_LEON">
                <component :is="tip.render" />
              </div>
            </div>
          </article>
        </div>

        <!-- Indicadores tipo “barra” (mockup) -->
        <div class="mt-6 flex items-center justify-center gap-3">
          <button v-for="(_, i) in tips" :key="i" type="button" class="h-[4px] w-[56px] rounded-full transition-opacity"
            :class="i === indice_activo ? 'bg-ROJO_LEON opacity-100' : 'bg-GRIS_BUTTONS opacity-70'"
            :aria-label="`Ir al tip ${i + 1}`" :aria-current="i === indice_activo ? 'true' : 'false'"
            @click="ir_a_slide(i)" />
        </div>
      </div>

      <!-- CTA -->
      <div class="mt-10 md:mt-12 flex justify-center">
        <button type="button" class="w-full md:w-[340px] h-[58px] rounded-xl
                 bg-ROJO_LEON text-BLANCO_LEON font-extrabold text-[18px]
                 shadow-md hover:bg-VINO_LEON transition-colors" @click="abrir_modal_agenda">
          Agenda tu cita ahora
        </button>
      </div>
    </div>
  </section>

  <ModalAgendaAceites v-if="mostrar_modal_agenda" @close="cerrar_modal_agenda" />

</template>

<script setup>
import { Fragment, h, nextTick, onMounted, ref } from 'vue'
import { markRaw } from "vue";

import ModalAgendaAceites from '~/components/Modals/ModalAgendaAceites.vue'

const mostrar_modal_agenda = ref(false)

const abrir_modal_agenda = () => {
  mostrar_modal_agenda.value = true
}

const cerrar_modal_agenda = () => {
  mostrar_modal_agenda.value = false
}
defineEmits(['agendar'])

/* =========================
   Render helpers (SIN JSX)
========================= */
const Strong = (txt) => h('strong', { class: 'font-extrabold text-GRIS_LEON' }, txt)

const Tip1 = {
  name: 'Tip1',
  setup() {
    return () =>
      h(Fragment, null, [
        h('p', 'El momento del cambio depende del tipo de aceite y tu conducción.'),
        h('p', [
          'En general, se recomienda cada 6 meses o ',
          Strong('10.000 km con aceite semi sintético'),
          ', y cada ',
          Strong('15.000 km si usas aceite sintético'),
          '.'
        ])
      ])
  }
}

const Tip2 = {
  name: 'Tip2',
  setup() {
    return () =>
      h(Fragment, null, [
        h('div', [
          h('p', { class: 'font-extrabold text-GRIS_LEON' }, 'Aceite Semi Sintético'),
          h('p', { class: 'mt-2' }, 'Buena protección, precio accesible y duración superior al mineral.')
        ]),
        h('div', [
          h('p', { class: 'font-extrabold text-GRIS_LEON' }, 'Aceite Sintético'),
          h('p', { class: 'mt-2' }, 'Mayor limpieza del motor, mejor desempeño en frío y calor, y máxima protección contra el desgaste.')
        ])
      ])
  }
}

const Tip3 = {
  name: 'Tip3',
  setup() {
    return () =>
      h(Fragment, null, [
        h('p', 'El aceite lubrica y protege el motor, pero con el uso se contamina y pierde efectividad.'),
        h('p', [
          'Un cambio periódico, junto al filtro, asegura ',
          Strong('mejor rendimiento'),
          ', ',
          Strong('menor desgaste'),
          ' y hasta ',
          Strong('ahorro de combustible'),
          '.'
        ])
      ])
  }
}

const Tip4 = {
  name: 'Tip4',
  setup() {
    return () =>
      h(Fragment, null, [
        h('p', [
          'En LEÓN el cambio de aceite y filtro demora entre ',
          Strong('30 y 50 minutos'),
          ', dependiendo del modelo de tu vehículo.'
        ]),
        h('p', [
          Strong('Puedes agendar en línea'),
          ' para asegurar tu hora o acercarte directamente a cualquiera de nuestros locales, donde nuestros técnicos estarán listos para atenderte.'
        ])
      ])
  }
}

/* =========================
   Tips (con tus imágenes)
========================= */

const tips = [
  {
    id: 1,
    imagen: '/img/aceites/imagenes/tips-1.png',
    alt: 'Aceite vertiéndose en el motor',
    titulo: '¿Cada cuánto hay que realizar el cambio de aceite y filtro?',
    render: markRaw(Tip1)
  },
  {
    id: 2,
    imagen: '/img/aceites/imagenes/tips-2.jpg',
    alt: 'Técnico realizando mantención de aceite',
    titulo: '¿Qué beneficios tiene cada tipo de aceite?',
    render: markRaw(Tip2)
  },
  {
    id: 3,
    imagen: '/img/aceites/imagenes/tips-3.jpg',
    alt: 'Filtro de aceite',
    titulo: '¿Por qué cambiar el aceite y el filtro?',
    render: markRaw(Tip3)
  },
  {
    id: 4,
    imagen: '/img/aceites/imagenes/tips-4.jpg',
    alt: 'Técnico de servicio automotriz',
    titulo: '¿Cuánto tarda el servicio en LEÓN Servicio Automotriz?',
    render: markRaw(Tip4)
  }
]


/* =========================
   Carrusel mobile: índice activo
========================= */
const track_ref = ref(null)
const indice_activo = ref(0)
let raf_id = null

function calcular_indice_activo() {
  const track = track_ref.value
  if (!track) return

  const slides = Array.from(track.querySelectorAll('article[data-index]'))
  if (!slides.length) return

  const centro = track.scrollLeft + track.clientWidth / 2

  let mejor = 0
  let mejor_dist = Infinity

  for (const el of slides) {
    const i = Number(el.dataset.index || 0)
    const el_centro = el.offsetLeft + el.clientWidth / 2
    const dist = Math.abs(el_centro - centro)
    if (dist < mejor_dist) {
      mejor_dist = dist
      mejor = i
    }
  }

  indice_activo.value = mejor
}

function on_scroll() {
  if (raf_id) cancelAnimationFrame(raf_id)
  raf_id = requestAnimationFrame(() => {
    calcular_indice_activo()
    raf_id = null
  })
}

function ir_a_slide(i) {
  const track = track_ref.value
  if (!track) return

  const el = track.querySelector(`article[data-index="${i}"]`)
  if (!el) return

  el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
}

onMounted(async () => {
  await nextTick()
  calcular_indice_activo()
})
</script>

<style scoped>
/* Ocultar scrollbar en mobile carrusel (sin romper scroll) */
.tips-track::-webkit-scrollbar {
  display: none;
}

.tips-track {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
